/**
 * Navigation Mega Dropdown
 * Handles click-based panel switching for the two-column dropdown mega menu.
 * Left column triggers (js-dropdown-trigger) match right column panels via data-panel index.
 */

(function () {
  'use strict';

  function initDropdownNav(wrap) {
    var triggers = wrap.querySelectorAll('.js-dropdown-trigger[data-panel]');
    var panels = wrap.querySelectorAll('.mega-nav--dropdown__panel');

    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        // If the trigger is an <a> tag (no grandchildren), let it navigate normally
        if (trigger.tagName === 'A') return;

        e.preventDefault();

        var idx = trigger.getAttribute('data-panel');
        var isAlreadyOpen = trigger.classList.contains('is-visible');
        var isFirst = trigger === triggers[0];

        triggers.forEach(function (t) { t.classList.remove('is-visible'); });
        panels.forEach(function (p) { p.classList.remove('is-visible'); });

        // Always keep open if clicking the already-open item or it's the first and nothing else is open
        if (!isAlreadyOpen || isFirst) {
          trigger.classList.add('is-visible');
          var panel = wrap.querySelector('.mega-nav--dropdown__panel[data-panel="' + idx + '"]');
          if (panel) panel.classList.add('is-visible');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.mega-nav--dropdown__wrap').forEach(initDropdownNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Theme Editor section reloads
  document.addEventListener('shopify:section:load', init);
})();
